import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, Markdown } from 'react-components'

export const NonCarouselContainer = styled.div`
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.row};
        justify-content: ${props => props.theme.style.justifyContent.spaceBetween};
        flex-wrap: ${props => props.theme.style.flexWrap.wrap};
        margin: 2.25rem auto 0;
        max-width: 1110px;
    }
`

export const Container = styled.section`
    padding: ${props => props.theme.spacing.xxLarge} 0 3.5rem;
    background-color: ${props => props.theme.colors.white};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 4.375rem 1.25rem 1.875rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 4.375rem 1.25rem 1.25rem;
    }
`

export const Title = styled.h2`
    padding: 0 0.625rem;
    margin: 0;
    font-size: 1.75rem;
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-weight: bold;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 2.125rem;
        padding: 0 1.25rem;
    }
`

export const BenefitsBasicCardContainer = styled.div`
    padding: 1.25rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0;
    }
`

export const BenefitsIndexCardContainer = styled.div`
    padding: ${props => props.theme.spacing.xSmall} 1.25rem;
`

export const CardContainer = styled.div`
    margin: ${props => props.theme.spacing.xLarge} ${props => props.theme.spacing.xSmall};
    min-height: 23.875rem;
    display: grid;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 43.88%;
        min-height: unset;
        margin: 0 0 2.5rem;
        padding: 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 30.36%;
        margin: 0 0 3.125rem;
    }
`

export const BenefitsIndexItemContainer = styled.div`
    padding: 0.625rem 0;
    display: ${props => props.theme.style.display.flex};
    align-items: center;
`

export const BenefitsCardIndexIconContainer = styled.img`
    height: ${props => props.theme.layout.small};
    width: ${props => props.theme.layout.small};
    margin-right: ${props => props.theme.spacing.medium};
`

export const BenefitsCardIndexText = styled.h3`
    margin: 0;
    font-size: ${props => props.theme.typography.font.size.medium};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: normal;
    color: ${props => props.theme.colors.tfwBlack87};
`

export const BenefitsCardBasicIconContainer = styled.img`
    height: ${props => props.theme.layout.medium};
    width: ${props => props.theme.layout.medium};
    margin-bottom: 1.25rem;
`

export const BenefitsCardBasicTitle = styled.div`
    font-size: ${props => props.theme.typography.font.size.xLarge};
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-weight: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    margin-bottom: ${props => props.theme.spacing.xSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-height: 3.625rem;
        margin: 0;
    }
`

export const BenefitsCardBasicDescription = styled(Markdown)`
    font-size: ${props => props.theme.typography.font.size.medium};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 300;
    line-height: 1.5rem;
    color: ${props => props.theme.colors.tfwBlack87};
    margin-bottom: ${props => props.theme.spacing.xSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        line-height: 1.38rem;
        margin: 0.5625rem 0 0;
    }

    & > p > a {
        color: ${props => props.theme.colors.tfwBlack87};
        font-weight: normal;
    }
`

export const SliderContainer = styled.ul`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    align-items: ${props => props.theme.style.alignItems.center};
    justify-content: ${props => props.theme.style.justifyContent.center};
    overflow: hidden;
`

export const Dot = styled.div<{ selected: boolean }>`
    border-radius: 0.3125rem;
    height: 0.625rem;
    width: 0.625rem;
    background-color: ${props => (props.selected ? props.theme.colors.feedbackGreen : props.theme.colors.tfwBlack12)};
`
